import React, { useState, useEffect } from "react";
import { useCompany } from "../../Context/CompanyContext"; // Usar el contexto directamente
import { fetchWithAuth } from "../../Context/UserContext"; // Asumimos que se utiliza para las peticiones
import API_URL from "../../config";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const Descripcion = () => {
  const { companies, fetchCompanies } = useCompany();
  const [editFormData, setEditFormData] = useState({});
  const [charCount, setCharCount] = useState(0); // Contador de caracteres
  const maxCharLimit = 2000; // Límite de caracteres

  useEffect(() => {
    if (companies?.profile) {
      // Inicializar estado solo con la descripción
      setEditFormData({
        profile: {
          descripcion: companies.profile.descripcion || "",
        },
      });
      setCharCount(companies.profile.descripcion?.length || 0); // Establecer el contador de caracteres inicial
    }
  }, [companies]);

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxCharLimit) {
      setEditFormData((prevFormData) => ({
        ...prevFormData,
        profile: {
          ...prevFormData.profile,
          descripcion: value,
        },
      }));
      setCharCount(value.length); // Actualizar el contador de caracteres
    }
  };

  const id_company = companies.company?.id_company;

  const handleSaveInfo = async () => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/bs/company-profile/${id_company}/update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company: {
              profile: {
                descripcion: JSON.stringify(editFormData.profile.descripcion), // 🔹 Guardar como JSON
              },
            },
          }),
        }
      );

      if (response.ok) {
        toast.success("Descripción de la empresa actualizada exitosamente.");
        fetchCompanies(); // Actualizar la lista de empresas en el contexto global
      } else {
        const data = await response.json();
        toast.error(`Error al actualizar la descripción: ${data.error}`);
      }
    } catch (error) {
      console.error("Error al actualizar la descripción:", error);
      toast.error("Error al actualizar la descripción de la empresa.");
    }
  };

  if (!editFormData?.profile) {
    return <div className="text-muted-foreground">Cargando datos de la empresa...</div>;
  }

  return (
    <Card>
      <CardContent className="space-y-3 pt-6">
        <h3 className="text-lg font-semibold text-foreground">Descripción de la Empresa</h3>
        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">
            Breve Descripción (máximo {maxCharLimit} caracteres):
          </label>
          <textarea
            value={editFormData.profile.descripcion || ""}
            placeholder="Describe brevemente tu empresa..."
            onChange={handleDescriptionChange}
            rows={6}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          />
          <small className="text-xs text-muted-foreground">
            {charCount}/{maxCharLimit} caracteres
          </small>
        </div>
        <Button onClick={handleSaveInfo}>Guardar Cambios</Button>
      </CardContent>
    </Card>
  );
};

export default Descripcion;
